import type { FaireProductEntity } from "../../entity_types/product";

export const p_kbbmnfdbcm: FaireProductEntity = {
  token: "p_kbbmnfdbcm",
  type: "product",
  name: "Round Neck Crop Top & High Waist Leggings Set",
  brandToken: "b_fhffj4w3rw",
  brandName: "Active Basic | Active USA",
  imageUrl:
    "https://cdn.faire.com/fastly/8070589e25e91e0d2109b7a2c78fce98c2b22d42269817f32a728ce4695a2296.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa24cd1f442b88b39a3af9dd62b5e3d97ac349bf9571a61d226120021a53a7cb.jpeg",
    "https://cdn.faire.com/fastly/5a01fea7bac61228011d93eca59e990452fde2e9ce386ebc2e474a098faf1ed9.jpeg",
    "https://cdn.faire.com/fastly/a2c214c6cf58f222400ef1c1a5c40942b3b78eebde1da613d789ade1100efbc2.jpeg",
    "https://cdn.faire.com/fastly/42b8fbd5ab39ee430c0dea9e311666e92743014b585e0a68c6edac35b68a5d27.jpeg",
    "https://cdn.faire.com/fastly/2cb6815902f345ea3cae9c0a46a8c7a6cb4bb3e8c2b43b36cea37e70fa351374.jpeg",
    "https://cdn.faire.com/fastly/8fc14206b7cea322858542f785a13d3ecd4ca300cb94fdd7436df8d4caa0f27c.jpeg",
    "https://cdn.faire.com/fastly/33c8a52180210d1a8fd17e8c1978804f8829e29965607b0da1a3001dc4b447fb.jpeg",
    "https://cdn.faire.com/fastly/17bb6464337a3d4fe4425c909e9614a62b3dedf13358c4aca6289cb9e6bfa330.jpeg",
    "https://cdn.faire.com/fastly/49b37d24712761811678b9dd1fbf471933e74d334cd9fa9ed3e211206f6f4919.jpeg",
    "https://cdn.faire.com/fastly/e59b186711614e23ee5ac8cca37fb891bef740971c1b4b1fd7cba1692afcd3bd.jpeg",
    "https://cdn.faire.com/fastly/01508b5eb262aa157a7df01ee8275ebed988dc5eb5c047c46e757415825e4347.jpeg",
    "https://cdn.faire.com/fastly/f220b347de4531efe78863952fa226af092df9c9ade9192e0d3ac69b31dea871.jpeg",
    "https://cdn.faire.com/fastly/c752702ace8962130b2dfb2a70c5c55d060ce301432440f6a4c8b1e10b9b6c6b.jpeg",
    "https://cdn.faire.com/fastly/db3d14df51798473a732a30a9740b7498c9da5c7bf547033292dbba08a931792.jpeg",
    "https://cdn.faire.com/fastly/4c5dd192f8165273df3b8764676f9fa5556057aab8f8690af5398b3b6e26333b.jpeg",
  ],
  priceDollars: 58.5,
  description:
    "ROUND NECK DOUBLE LAYER EFFECT CROP TOP AND HIGH WAIST CONTRAST WAISTBAND LEGGINGS SET\n\nFABRIC: SEAMLESS\n92% NYLON 8% SPANDEX\n\n- new arrivals, active basic, active usa, essential, trending, must have, activewear, matching set, yoga, pilates, workout. seamless set",
  tags: [],
  msrpDollars: 117,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:06.633Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
